class customSort extends HTMLElement {
    constructor() {
        super();

        this.dropDownBtn = this.querySelector("[js-dropdown-header]");
        this.sortOption = this.querySelectorAll("[js-sort-item]");

        if(this.dropDownBtn) {
            this.initDropdown();
        }
        this.initSort();

        document.addEventListener("sort:init", () => {
            this.initSort.bind(this);
        })
        document.addEventListener("dropdown:init", () => {
            this.initDropdown.bind(this);
        })
    };

    initDropdown() {
        const self = this;
        this.dropDownBtn.addEventListener("click", function () {
            const dropDownPanel = this.nextElementSibling;
            self.toggleDropdown(dropDownPanel);
        });

        document.addEventListener("click", (event) => {
            const dropDownPanel = this.querySelector("[js-dropdown-panel]");

            if(!this.contains(event.target)) {
                this.close(dropDownPanel)
            }
        });
    };

    toggleDropdown(panel) {
        panel.classList.toggle("active");
    };

    close(panel) {
        panel.classList.remove("active");
    };

    initSort() {
        const self = this;
        this.defaultSort = this.getDefaultSortValue();
        this.sortOption.forEach( option => {
            option.on('click', function() {
                self.onSortChange(this)
            });
        })
    };
  
    getSortValue(option) {
        return option.getAttribute('data-sort-value') || this.defaultSort;
    };
  
    getDefaultSortValue() {
        return this.getAttribute('data-default-sortby');
    };
  
    onSortChange(option) {
        this.queryParams = new URLSearchParams(window.location.search);

        if(this.dropDownBtn) {
            this.updateSortHeading(option);
        };

        this.changeActiveState(option);
  
        this.queryParams.set('sort_by', this.getSortValue(option));
        this.queryParams.delete('page'); // Delete if it exists

        if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
        };

        document.dispatchEvent(new CustomEvent('startLoading:init'));
        document.dispatchEvent(new CustomEvent('updateScroll:init'));
        document.dispatchEvent(new CustomEvent('renderCollectionPage',  {
          detail: {
            newUrl: this.queryParams
          }
        }));
    };

    updateSortHeading(option) {
        const selectedOption = option.innerText;
        const dropDownPanel = this.querySelector("[js-dropdown-panel]");
        this.dropDownBtn.querySelector(".sort-heading").innerText = selectedOption;    

        this.close(dropDownPanel);
    }

    changeActiveState(option) {
        this.sortOption.forEach( item => item.classList.remove("selected"));
        option.classList.add("selected")
    }

}
  
customElements.define('custom-sort', customSort);
  